module.exports = __webpack_public_path__ + "media/images/front/common/icon_column-51bd83e42967128473ce94b9e12afed6.svg";